import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIobrokerComponent } from './simple-icons-iobroker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIobrokerComponent ],
    exports:      [ SimpleIconsIobrokerComponent ],
    bootstrap:    []
})
export class SimpleIconsIobrokerModule {}
